import React from 'react';

const ScrollableContentViewer = ({ content, useHtml=true }) => {  
	return (
		<iframe
			// Intigriti A9SENNW5: template-controlled `content` is rendered as HTML in the
			// iframe srcDoc. Sandbox without `allow-scripts` (and without `allow-same-origin`)
			// so injected <script>/on* handlers cannot execute; popups + user-activated
			// top navigation stay enabled so legitimate links still work.
			sandbox="allow-popups allow-top-navigation-by-user-activation"
			srcDoc={useHtml ? content : `<div>${content}</div>`}
			style={{
				overflowY: 'scroll',
				border: '1px solid black',
				borderRadius: '10px',
				minHeight: '450px',
				width: '100%',
			}}
		/>
	);
};

ScrollableContentViewer.type = 'ScrollableContentViewer';
ScrollableContentViewer.spec = [
	{
		name: 'ScrollableContentViewer',
		key: 'legal-box',
		icon: 'Book',
		title: 'Legal box',
		category: 'layout',
		defaultProperties: {
			useHtml: true,
		},
		fields: [
			{
				type: 'Checkbox',
				label: 'Use HTML content?',
				name: 'useHtml',
			},
			{
				type: 'TextArea',
				label: 'Content',
				name: 'content',
				placeholder: 'Body Content',
			}],
	},
];

export default ScrollableContentViewer;